import React from 'react';
import TextInput from '../widgets/TextInput';
import StipendiTable from './StipendiTable';

export default class StipendiComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            importo: this.props.importo, 
            stipendi: this.props.stipendi,
        };
    }

    componentDidUpdate() {
        if (this.state.importo !== this.props.importo || this.state.stipendi !== this.props.stipendi) {
            this.setState({ importo: this.props.importo, stipendi: this.props.stipendi });
        }
    }

    render() {

        if (this.props.nessuno) {
            return(
                <div style={{ ...mainStyle, opacity: 0.7 }}>
                    <p style={{ ...child, marginTop: 10, opacity: 0.7 }} >Nessuno stipendio trovato</p>
                </div>
            );
        }

        return(
            <>
            {this.props.passati ?
                (
                    <div style={mainStyle}>
                        <img src={require('../images/uscita.png')} alt="" style={{ width: 25, height: 25, marginLeft: 10, marginTop: 5 }} />
                        <p style={{ ...child, marginTop: 10 }} >{this.props.testo}</p>
                    </div>
                ) : (
                    <>
                    {false ? (
                        <div style={mainChanging}>
                            <img src={require('../images/uscita.png')} alt="" style={{ width: 25, height: 25, marginLeft: 10, marginTop: 10, marginRight: 20 }} />
                            <TextInput noState={true} name={''} value={this.state.importo}
                                onChange={(text) => {
                                    var t = text.replace(/\./g, '');
                                    if(/[^0-9,]+/.test(t)) {
                                        t = t.replace(/[^0-9]+/g, '');
                                    }
                                    var chunks = t.split(',');
                                    chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    t = chunks.join(',');
                                    this.setState({importo: t});
                                    this.props.onStipendioChange(t);
                                }}
                            />
                            <p style={{ marginLeft: 10 }}>€</p>
                        </div>) : 
                    <StipendiTable stipendi={this.state.stipendi} onChange={(stipendi) => {
                        
                        this.props.onChange(stipendi);
                        this.setState({ stipendi });
                    }} />
                    }
                    </>
                )
            }
            </>
        );
    }
}

const mainStyle = {
    display: 'flex', 
    flexDirection: 'row', 
    marginBottom: 10, 
    borderRadius: 5,
    border: '1px solid darkgrey',
    maxHeight: 60,
    paddingTop: 10, 
    paddingBottom: 10, 
    paddingLeft: 10, 
    paddingRight: 10,
};

const mainChanging = {
    display: 'flex', 
    flexDirection: 'row', 
    marginBottom: 10, 
    borderRadius: 5,
    border: '1px solid darkgrey',
    maxHeight: 70,
    paddingTop: 10, 
    paddingBottom: 10, 
    paddingLeft: 10, 
    paddingRight: 10,
};

const child = {
    marginLeft: 5,
    height: 40,
}
 
